export const styles = {
  tab: {
    base: "relative flex h-10 items-center whitespace-nowrap px-4 py-2.5 text-sm font-medium outline-none transition-colors duration-300 ease-in-out",
    border: {
      vertical: "!ml-0 border-l-2",
      horizontal: "border-b-2",
    },
    active: {
      base: "border-blue-600 text-blue-600",
      vertical:
        "after:absolute after:left-0 after:top-0 after:h-full after:w-[2px] after:-translate-x-[2px] after:bg-blue-600/20 after:blur-sm",
      horizontal:
        "after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-full after:translate-y-[2px] after:bg-blue-600/20 after:blur-sm",
    },
    inactive: "border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-800",
  },
  panels: {
    container: "flex-grow overflow-auto",
    panel: "h-full rounded-xl bg-white focus:outline-none",
    header: "mb-6 border-b border-gray-200 pb-4",
    title: "text-2xl font-semibold text-gray-900",
    description: "mt-2 text-sm text-gray-600",
  },
};
